import { render, staticRenderFns } from "./GoodsForm3.vue?vue&type=template&id=c36e2c02&scoped=true&"
import script from "./GoodsForm3.vue?vue&type=script&lang=js&"
export * from "./GoodsForm3.vue?vue&type=script&lang=js&"
import style0 from "./GoodsForm3.vue?vue&type=style&index=0&id=c36e2c02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36e2c02",
  null
  
)

export default component.exports